import { connect, ConnectedProps } from 'react-redux';

import {
  resetBuyerFlow,
  setBuyerFlowCurrentStep,
} from '../state/actions';

import BuyerOnboardingReset from '../components/BuyerOnboardingReset';

import { IBuyerFlowData } from '../interfaces';
interface RootState {
    sellerFlow: IBuyerFlowData;
    darkMode: boolean;
    isConsideredMobile: boolean;
}
  
const mapStateToProps = (state: RootState) => ({
    darkMode: state.darkMode,
    isConsideredMobile: state.isConsideredMobile,
})

const mapDispatchToProps = {
  setBuyerFlowCurrentStep,
  resetBuyerFlow,
}
  
const connector = connect(mapStateToProps, mapDispatchToProps)
  
export type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(BuyerOnboardingReset)